import React from 'react';
import { Skeleton, SxProps, Theme } from '@mui/material';

interface TableCellBoneProps {
    /** Mode header ou cell normal */
    isHeader?: boolean;
    /** Animation */
    animation?: 'pulse' | 'wave' | false;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const TableCellBone: React.FunctionComponent<TableCellBoneProps> = function ({
    isHeader = false,
    animation = 'pulse',
    sx = {},
}) {
    return (
        <Skeleton
            variant="rounded"
            animation={animation}
            role="progressbar"
            sx={{
                height: isHeader ? '56px' : '32px',
                flex: 1,
                ...sx,
            }}
        />
    );
};
